import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard as AdminGuard } from './guards/admin.guard';
import { StudentGuard } from './guards/student.guard';
import { ManagerGuard } from './guards/manager.guard';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: '/auth2/loginBook',
    },
    {
        path: 'charts',
        loadChildren: () =>
            import('modules/charts/charts-routing.module').then(m => m.ChartsRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'dashboard',
        loadChildren: () =>
            import('modules/dashboard/dashboard-routing.module').then(
                m => m.DashboardRoutingModule
            ),
        canActivate: [AdminGuard]
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('modules/auth/auth-routing.module').then(m => m.AuthRoutingModule),
    },
    {
        path: 'error',
        loadChildren: () =>
            import('modules/error/error-routing.module').then(m => m.ErrorRoutingModule),
    },
    {
        path: 'tables',
        loadChildren: () =>
            import('modules/tables/tables-routing.module').then(m => m.TablesRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'version',
        loadChildren: () =>
            import('modules/utility/utility-routing.module').then(m => m.UtilityRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'auth2',
        loadChildren: () =>
            import('pages/auth/auth-routing.module').then(m => m.AuthRoutingModule),
    },
    {
        path: 'users',
        loadChildren: () =>
            import('pages/users/users-routing.module').then(m => m.UsersRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'courses',
        loadChildren: () =>
            import('pages/courses/courses-routing.module').then(m => m.CoursesRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'classes',
        loadChildren: () =>
            import('pages/classes/classes-routing.module').then(m => m.ClassesRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'books',
        loadChildren: () =>
            import('pages/books/books-routing.module').then(m => m.BooksRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'schools',
        loadChildren: () =>
            import('pages/schools/schools-routing.module').then(m => m.SchoolsRoutingModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'reports',
        loadChildren: () =>
            import('pages/reports/reports-routing.module').then(m => m.ReportsRoutingModule),
        canActivate: [ManagerGuard]
    },
    {
        path: 'student',
        loadChildren: () =>
            import('pages/doing-class/doing-class-routing.module').then(m => m.DoingClassRoutingModule),
        canActivate: [StudentGuard]
    },
    {
        path: '**',
        pathMatch: 'full',
        loadChildren: () =>
            import('modules/error/error-routing.module').then(m => m.ErrorRoutingModule),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
